import { render, staticRenderFns } from "./ClientsModal.vue?vue&type=template&id=b2049db4&scoped=true&"
import script from "./ClientsModal.vue?vue&type=script&lang=js&"
export * from "./ClientsModal.vue?vue&type=script&lang=js&"
import style0 from "./ClientsModal.vue?vue&type=style&index=0&id=b2049db4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2049db4",
  null
  
)

export default component.exports